import React, { Component } from 'react';
import axios from 'axios';
import cookie from 'react-cookie';
import {Fairs} from 'api';
import Modal from 'react-modal'
import {toastr} from 'react-redux-toastr';
import {Link} from 'react-router-dom'

export default class FairAds extends Component {
  constructor(props) {
    super(props)
    this.state = {
      access_token: cookie.load('accessToken') || '',
      API_URL: '',
      listAd: [],
      index: '',
      image: '',
      link: '',
      modalIsOpen:false,
      loading: false
    }
  }

  componentWillMount () {
    Modal.setAppElement('body')
  }

  componentDidMount() {
    this.getDetail();
  }

  getDetail() {
    Fairs.actions.get.request({id: this.props.params.id}).then(response => {
      if (response) {
        let Fair = response.data && response.data.fair
        this.setState({
          API_URL: Fair && Fair.apiUrl || '',
          listAd: Fair.additionalModulesInfo && Fair.additionalModulesInfo.data ? Fair.additionalModulesInfo.data : []
        })
      }
    })
  }

  closeModal() {
    this.setState({modalIsOpen: false, index: '', loading: false, image: '', link: ''})
  }

  showPopup(type, item, index, e) {
    console.log(type, item, index, e)
    if(type === 'create') {
      this.setState({
        image: '',
        link: '',
        modalIsOpen: true
      })
    } else {
      this.setState({
        index,
        image: item.image || '',
        link: item && item.link ? item.link : '',
        modalIsOpen: true
      })
    }
  }

  onRemoveImage() {
    this.setState({image: ''})
  }

  onChange(e) {
    this.setState({
      link: e.target.value
    })
  }

  onChangeFile(e) {
    let reader = new FileReader();
    let file = e.target.files[0];
    let data = new FormData();
    data.append('fileUpload', file);
    axios({
      method: 'POST',
      url:`${this.state.API_URL}/containers/fairs/upload`,
      headers: {
        Authorization: `${this.state.access_token}`
      },
      data: data
    }).then(response => {
      this.setState({
        image: response.data.result.files['fileUpload'][0]['name']
      })
    })
  }

  saveData() {
    if (this.validate()) {
      this.setState({loading: true})
      let listAd = [...this.state.listAd];
      if (this.state.index !== '') {
        listAd[this.state.index] = {image: this.state.image, link: this.state.link}
      } else {
        listAd = [...listAd, {image: this.state.image, link: this.state.link}]
      }
      let data = {
        additionalModulesInfo: {
          data: listAd
        }
      }
      Fairs.actions.update.request({id: this.props.params.id}, data).then(response => {
        toastr.removeByType('success');
        toastr.success("Thành công", "Cập nhật thông tin thành công");
        this.setState({
          image: '',
          link: '',
          modalIsOpen: false,
          loading: false
        }, () => {
          this.getDetail()
        })
      }).catch(err => {
        this.setState({loading: false})
      })
    }
  }

  validate() {
    if (!this.state.image) {
      toastr.error("Lỗi", "Vui lòng tải lên banner quảng cáo");
      return false
    }
    return true
  }

  render() {
    let listAd = this.state.listAd && this.state.listAd.map((item, index) => {
      return(
        <tr className='item-banner-category' key={index}>
          <td style={{textAlign: 'center'}}>{index + 1}</td>
          <td>{item.image ? (<img className='banner' alt='' src={`${this.state.API_URL}/containers/fairs/download/${item.image}`}/>) : (<p>Chưa có banner</p>)}</td>
          <td>{item.link ? (<a href={item.link} target='_blank' className='txt-link-banner'>{item.link}</a>) : (<p>Chưa có liên kết</p>)}</td>
          <td>
            <div className='wrap-actions text-center'>
              <button className='btn btn-primary mb5' onClick={this.showPopup.bind(this, 'update', item, index)}>Cập nhật thông tin</button>
            </div>
          </td>
        </tr>
      )
    })
    return (
      <div>
        <div className='wrap-heading'>
          <h1>Quản lý quảng cáo hội chợ</h1>
          <div className='list-actions'>
            <Link to="#" onClick={this.showPopup.bind(this, 'create')}>Thêm quảng cáo mới</Link>
          </div>
        </div>
        <div>
          <table className='list-banner-category'>
            <thead>
              <tr>
                <th style={{width: 50, minWidth: 50, maxWidth: 50, textAlign: 'center'}}>STT</th>
                <th style={{width: 270, minWidth: 270 }}>Banner</th>
                <th style={{width: 300 }} className='txt-link-banner'>Liên kết quảng cáo</th>
                <th style={{minWidth: 170, width: 170 }}>Thao tác</th>
              </tr>
            </thead>
            <tbody>
              {listAd}
            </tbody>
          </table>
        </div>
        <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal.bind(this)}
            className='modal-custom modal-category'
          >
            <div className='title-block'>
              <button className='btn-close' onClick={this.closeModal.bind(this)}>×</button>
            </div>
            <div className='wrap-content-modal'>
              <h4 className='content-message text-center'>{this.state.index ? 'Chỉnh sửa quảng cáo' : 'Thêm mới quảng cáo'}</h4>
              <div className='wrap-upload'>
                <div className='input-upload'>
                  <input type='file' value='' onChange={this.onChangeFile.bind(this)} />
                  <p className="fa fa-cloud-upload" />
                  <p>Upload banner</p>
                </div>
                <div className='preview-image'>
                  {this.state.image && (
                    <div className='wrap-image'>
                      <button className='btn-delete' onClick={this.onRemoveImage.bind(this)}>×</button>
                      <img src={`${this.state.API_URL}/containers/fairs/download/${this.state.image}`} />
                    </div>
                    )}
                </div>
              </div>
              <h4 className='content-message text-center'>Liên kết quảng cáo</h4>
              <input type='text' className='input-link' value={this.state.link} onChange={this.onChange.bind(this)} />
              <div className='wrap-btn-action'>
                <button className='btn btn-primary' disabled={this.state.loading} onClick={this.saveData.bind(this)}>Lưu</button>
              </div>
            </div>
          </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/fair/FairAds.jsx